// extracted by mini-css-extract-plugin
export default {"root":"Card_root__db1BI","soft":"Card_soft__9TxO4"};